import { selectTournamentPickemFilterOptions } from "selectors/Tournament";
import { useFilter } from "./Filters";
import { useAppSelector } from "app/hooks";

export const useTournamentPickemFilter = (
  year: string,
  initialValue?: string
) => {
  const tournamentOptions =
    useAppSelector((state) =>
      selectTournamentPickemFilterOptions(state, year)
    ) ?? [];

  return useFilter(tournamentOptions, initialValue);
};
